(() => {
  const init = (scope = document) => {
    const root = scope.matches?.('[data-powlife-product]') ? scope : scope.querySelector?.('[data-powlife-product]');
    if (!root) return;
    const hero = root.querySelector('.pl-pdp__hero');
    const gallery = root.querySelector('.pl-gallery');
    const buy = root.querySelector('.pl-buy');
    if (!hero || !gallery || !buy) return;

    let head = hero.querySelector(':scope > .pl-mobile-product-head');
    if (!head) {
      head = document.createElement('div');
      head.className = 'pl-mobile-product-head';
      head.setAttribute('aria-label', 'Product information');
      hero.insertBefore(head, gallery);
    }

    const title = buy.querySelector(':scope > h1');
    if (title && !head.querySelector('h1')) head.appendChild(title.cloneNode(true));

    const sourcePrice = buy.querySelector('[data-product-price]');
    let mobilePrice = head.querySelector('[data-mobile-product-price]');
    if (sourcePrice && !mobilePrice) {
      mobilePrice = sourcePrice.cloneNode(true);
      mobilePrice.removeAttribute('data-product-price');
      mobilePrice.setAttribute('data-mobile-product-price', '');
      mobilePrice.querySelectorAll('[data-product-sale-price],[data-product-compare-price],[data-product-current-price]').forEach(el => {
        el.removeAttribute('data-product-sale-price');
        el.removeAttribute('data-product-compare-price');
        el.removeAttribute('data-product-current-price');
      });
      head.appendChild(mobilePrice);
    }

    const syncReview = () => {
      const sourceReview = buy.querySelector('.pl-buy__review-jump');
      let mobileReview = head.querySelector('.pl-buy__review-jump');
      if (sourceReview && !mobileReview) {
        mobileReview = sourceReview.cloneNode(true);
        if (mobilePrice) head.insertBefore(mobileReview, mobilePrice);
        else head.appendChild(mobileReview);
      }
      if (mobileReview && mobilePrice && mobileReview.nextElementSibling !== mobilePrice) {
        head.insertBefore(mobileReview, mobilePrice);
      }
    };
    syncReview();

    if (sourcePrice && mobilePrice && !sourcePrice.dataset.mobilePriceSync) {
      sourcePrice.dataset.mobilePriceSync = 'true';
      const sync = () => {
        mobilePrice.innerHTML = sourcePrice.innerHTML;
        mobilePrice.querySelectorAll('[data-product-sale-price],[data-product-compare-price],[data-product-current-price]').forEach(el => {
          el.removeAttribute('data-product-sale-price');
          el.removeAttribute('data-product-compare-price');
          el.removeAttribute('data-product-current-price');
        });
      };
      sync();
      new MutationObserver(sync).observe(sourcePrice, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['hidden']});
    }

    if (!buy.dataset.mobileReviewSync) {
      buy.dataset.mobileReviewSync = 'true';
      new MutationObserver(syncReview).observe(buy, {childList:true, subtree:true});
    }
  };

  const boot = () => document.querySelectorAll('[data-powlife-product]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', e => init(e.target));
  document.addEventListener('hpr:review-jump-ready', boot);
})();
